import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/styles/reset.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Sticky from 'vue-sticky-directive'
import VueClipboard from 'vue-clipboard2'
import VueAnimXYZ from '@animxyz/vue'
import VueLazyload from 'vue-lazyload'
import '@animxyz/core'
Vue.use(VueAnimXYZ)
Vue.use(VueClipboard)
Vue.use(VueLazyload)


Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(Sticky)

new Vue({
  router,
  store,
  mounted () {
    document.dispatchEvent(new Event('my-app-dz'))
  },
  render: h => h(App),
}).$mount('#app')
